import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

const Button = ({ children, variant = 'primary', className, ...props }) => {
  const baseStyles = "inline-flex items-center justify-center px-6 py-3 font-semibold rounded-md transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-alpha-green hover:bg-alpha-greenLight text-white focus:ring-alpha-green shadow-lg shadow-alpha-green/20",
    secondary: "bg-alpha-navy hover:bg-alpha-navyLight text-white focus:ring-alpha-navy shadow-lg shadow-alpha-navy/20",
    outline: "border-2 border-alpha-navy text-alpha-navy hover:bg-alpha-navy hover:text-white focus:ring-alpha-navy",
    ghost: "text-alpha-navy hover:bg-alpha-grayLight focus:ring-alpha-navy",
    white: "bg-white text-alpha-navy hover:bg-gray-50 focus:ring-white shadow-lg",
  };

  return (
    <motion.button 
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={cn(baseStyles, variants[variant], className)}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;